//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    compressorData_GetAlertsForCompressors(frameSerialNumber: string, startDate?: string | null | undefined, endDate?: string | null | undefined): Promise<CompressorAlert_ExternallyShared[]>;
    compressorData_GetFleetAlertsForTimeRange(startDate?: string | null | undefined, endDate?: string | null | undefined): Promise<CompressorAlert_ExternallyShared[]>;
    compressorData_GetDataForCompressors(frameSerialNumber?: string[] | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined): Promise<HistoricalPropertyValuesForCompressor[]>;
    compressorData_GetClearancesForCompressor(frameSerialNumber?: string[] | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined): Promise<HistoricalPropertyValuesForCompressor[]>;
    compressorData_GetGasesForCompressors(frameSerialNumber?: string[] | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined): Promise<HistoricalPropertyValuesForCompressor[]>;
    legacyThingworx_GetLegacyCompressorStatusSummary(body: LegacyCompressorFrameIdDTO): Promise<CompressorStatusSummary_LegacyWrapper>;
    r_D_GetAvailableVariablesForFrame(frameSerialNumber: string): Promise<ChartingVariable[]>;
    r_D_GetChartData(parameters: ChartingDataParams): Promise<ChartingVariable[]>;
    r_D_GetClearanceData(frameSerialNumber: string): Promise<CompressorPropertyWithValue[]>;
    r_D_GetCompressors(): Promise<Compressor[]>;
    bearing_GetBearingTemperatures(frameSerialNumber: string): Promise<CompressorPropertyWithValue[]>;
    chart_GetChartVariables(frameId: string): Promise<ChartingVariable[]>;
    chart_GetChartData(parameters: ChartingDataParams): Promise<ChartingVariable[]>;
    chart_GetLubeOilChartData(parameters: ChartingDataParams): Promise<LubeOilChartData>;
    chart_GetChartDataForExport(parameters: ChartingDataParams): Promise<{ [key: string]: string; }[]>;
    cylinder_GetTelemetryProperties(cylinderSN: string, frameSerialNumber?: string | undefined, isHETandem?: boolean | undefined): Promise<CylinderTelemetryProperty[]>;
    cylinder_GetCylinderEndTelemetry(cylinderSerialNumber: string, frameSerialNumber?: string | undefined, throwNumber?: string | undefined): Promise<DisplayNameValue[]>;
    defaultNotification_GetDefaultNotificationsForCompressor(frameSerialNumber: string): Promise<DefaultNotificationDTO[]>;
    defaultNotification_UpdateNotificationForCompressorAndUser(frameSerialNumber: string, notificationToUpdate: DefaultNotificationDTO): Promise<DefaultNotificationDTO>;
    favorites_AddFavorite(frameSerialNumber: string): Promise<FileResponse>;
    favorites_DeleteFavorite(frameSerialNumber: string): Promise<FileResponse>;
    featureFlag_GetFeatureFlags(): Promise<FeatureFlag[]>;
    mlinkFirmware_GetMlinkFirmwareRevisions(): Promise<number[]>;
    mlinkFirmware_GetMlinkFirmwareRevisionsForCompressors(frameSerialNumbers?: string[] | undefined): Promise<CompressorMlinkFirmwareRevisionDTO[]>;
    mlinkFirmware_RequestUpdate(updateRequest: RequestFirmwareConfigUpdateDTO): Promise<void>;
    notification_GetNotificationRulesForCompressor(frameSerialNumber: string): Promise<CompressorNotificationRule[]>;
    notification_GetNotificationRulesForFleet(): Promise<CompressorNotificationRule[]>;
    notification_GetNotificationRuleDetails(notificationRuleID: number, subscriptionID: number): Promise<NotificationDetail[]>;
    notification_GetCanNotificationBeDeleted(ruleID: number): Promise<boolean>;
    notification_UpdateNotifications(notificationValues: NotificationRuleValuesDTO): Promise<boolean>;
    notification_CreateNotification(notificationValues: NotificationRuleValuesDTO): Promise<boolean>;
    notification_DeleteNotification(ruleID: number): Promise<boolean>;
    notification_GetNotificationSubscribers(ruleID: number): Promise<NotificationSubscriber[]>;
    notificationPreferences_GetNotificationPreferences(): Promise<NotificationPreferences>;
    notificationPreferences_UpdatePhoneNumber(verificationCheckDto: VerificationCheckDTO): Promise<FileResponse>;
    organization_GetUserParentOrganizations(): Promise<Organization[]>;
    organization_GetOrganizationHierarchyForOrg(orgId: number): Promise<HierarchyItem[]>;
    organization_GetOrganizationHierarchyForLoggedInUser(): Promise<HierarchyItem[]>;
    organization_GetMembersOnlyUsersForOrganization(organizationId: string): Promise<MembersOnlyUser[]>;
    organization_GetIsArielEmployee(): Promise<boolean>;
    organization_DeleteUsers(organizationId: string, users: UserToDeleteDTO[]): Promise<DeleteUserResponse>;
    organization_UpdateUser(requestBody: UpdateUserRequestBody, organizationId: string): Promise<Response>;
    organization_CreateCompressorOrgAssociation(frameSerialNumber: string, organizationId: number): Promise<boolean>;
    organization_DeleteCompressorOrgAssociation(frameSerialNumber: string, organizationId: number): Promise<FileResponse>;
    organization_GetOrganizationsWithAccessToCompressor(frameSerialNumber: string): Promise<OrganizationsWithAccessToCompressorDto[]>;
    packingVent_GetPackingVentPredictions(organizationId?: number | null | undefined): Promise<FleetPackingData>;
    packingVent_GetPackingVentDataForCompressor(frameSerialNumber: string, startDate?: string | undefined, endDate?: string | undefined): Promise<FramePackingHistoricalData>;
    report_GetFleetSoftwareVersionReport(): Promise<SoftwareVersionFleetReport[]>;
    report_GetDataQualityReportForFrame(frameSerialNumber: string): Promise<DataQualityReport>;
    report_GetDataQualitySummaryForFrame(frameSerialNumber: string): Promise<boolean>;
    report_GetDataQualityReportsForFleet(organizationId?: number | null | undefined): Promise<DataQualityReport[]>;
    sensorReliability_GetFleetSensorReliabilityReport(organizationId?: number | null | undefined): Promise<FleetSensorReliabilitySummary>;
    sensorReliability_GetHistoricalFleetSensorReliabilityReport(startDate?: string | undefined, endDate?: string | undefined, organizationId?: number | null | undefined): Promise<HistoricalFleetSensorReliabilitySummary>;
    termsAndConditions_GetTermsAndConditions(): Promise<TermsAndConditions>;
    termsAndConditions_GetTermsAndConditionsStatus(): Promise<TermsAndConditionsStatus>;
    termsAndConditions_UpdateTermsAndConditionsStatus(status: string): Promise<FileResponse>;
    verificationCode_SendVerification(phoneNumber: string): Promise<boolean>;
    verificationCode_CheckVerification(body: VerificationCheckDTO): Promise<boolean>;
    vibrations_GetVibrationData(frameSerialNumber: string): Promise<VibrationOverviewResponse>;
    alert_Get(alertResolutionType?: string | undefined, resolutionStartDate?: string | null | undefined, resolutionEndDate?: string | null | undefined): Promise<CompressorAlert[]>;
    alert_GetAlertSetPoints(frameId: string): Promise<AlertSetPoint[]>;
    alert_GetCompressorAlertsByResolutionStatus(frameId: string, alertResolutionType?: string | undefined, resolutionStartDate?: string | null | undefined, resolutionEndDate?: string | null | undefined): Promise<CompressorAlert[]>;
    alert_GetAllCompressorAlertsForTimeRange(frameSerialNumber: string, startDate?: string | undefined, endDate?: string | undefined): Promise<CompressorAlert[]>;
    alert_GetFaultRepositoryEntries(): Promise<FaultRepositoryGenericFaultGroup[]>;
    compressor_GetAll(onlyFavorites?: boolean | undefined): Promise<Compressor[]>;
    compressor_GetCompressorConditions(frameId: string): Promise<CompressorConditions>;
    compressor_Get(frameId: string): Promise<CompressorBasicInformation>;
    compressor_GetCompressorOperationalStatusCode(frameId: string): Promise<number>;
    compressor_GetCompressorStatus(frameId: string): Promise<CompressorStatus>;
    compressor_UpdateCompressorEndUserUnitId(frameId: string, endUserUnitId?: string | undefined): Promise<boolean>;
    compressor_GetCurrentValveDataForCompressor(frameSerialNumber: string): Promise<StageValveTempAndLeakIndexData[]>;
    compressor_GetCompressorStatusSummary(frameId: string): Promise<CompressorStatusSummary[]>;
    compressor_GetLubeOilConditions(frameSerialNumber: string, volumeUnits?: VolumeUnits | undefined): Promise<LubeOilData>;
    compressor_GetConfigDiagram(frameSerialNumber: string): Promise<ISerialNumberedEquipment[][]>;
    compressor_GetThrowRodLoadTelemetry(frameSerialNumber: string, throwNumber: string): Promise<DisplayNameValue[]>;
    compressor_GetThrowStageMapping(frameSerialNumber: string): Promise<ThrowStageMapping[]>;
    compressor_GetPropertiesForCompressor(frameSerialNumber: string): Promise<CompressorProperty[]>;
    compressor_GetTelemetryReadings(frameSerialNumber: string): Promise<{ [key: string]: string; }>;
    compressor_GetEndUser(frameSerialNumber: string): Promise<string>;
    compressor_UpdateEndUserForCompressor(frameSerialNumber: string, subOrgName: string): Promise<boolean>;
    compressor_GetCurrentSetPointsForCompressor(frameSerialNumber: string): Promise<CompressorPropertyWithValue[]>;
    compressor_GetLatestLocationForCompressors(): Promise<CompressorLatLong[]>;
    config_Get(): Promise<FrontEndConfig>;
}

export class Client implements IClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    compressorData_GetAlertsForCompressors(frameSerialNumber: string, startDate?: string | null | undefined, endDate?: string | null | undefined, cancelToken?: CancelToken): Promise<CompressorAlert_ExternallyShared[]> {
        let url_ = this.baseUrl + "/api/external/compressors/{frameSerialNumber}/alerts?";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressorData_GetAlertsForCompressors(_response);
        });
    }

    protected processCompressorData_GetAlertsForCompressors(response: AxiosResponse): Promise<CompressorAlert_ExternallyShared[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorAlert_ExternallyShared[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorAlert_ExternallyShared[]>(null as any);
    }

    compressorData_GetFleetAlertsForTimeRange(startDate?: string | null | undefined, endDate?: string | null | undefined, cancelToken?: CancelToken): Promise<CompressorAlert_ExternallyShared[]> {
        let url_ = this.baseUrl + "/api/external/compressors/alerts?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressorData_GetFleetAlertsForTimeRange(_response);
        });
    }

    protected processCompressorData_GetFleetAlertsForTimeRange(response: AxiosResponse): Promise<CompressorAlert_ExternallyShared[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorAlert_ExternallyShared[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorAlert_ExternallyShared[]>(null as any);
    }

    compressorData_GetDataForCompressors(frameSerialNumber?: string[] | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, cancelToken?: CancelToken): Promise<HistoricalPropertyValuesForCompressor[]> {
        let url_ = this.baseUrl + "/api/external/compressors/data?";
        if (frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' cannot be null.");
        else if (frameSerialNumber !== undefined)
            frameSerialNumber && frameSerialNumber.forEach(item => { url_ += "frameSerialNumber=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressorData_GetDataForCompressors(_response);
        });
    }

    protected processCompressorData_GetDataForCompressors(response: AxiosResponse): Promise<HistoricalPropertyValuesForCompressor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HistoricalPropertyValuesForCompressor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoricalPropertyValuesForCompressor[]>(null as any);
    }

    compressorData_GetClearancesForCompressor(frameSerialNumber?: string[] | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, cancelToken?: CancelToken): Promise<HistoricalPropertyValuesForCompressor[]> {
        let url_ = this.baseUrl + "/api/external/compressors/clearances?";
        if (frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' cannot be null.");
        else if (frameSerialNumber !== undefined)
            frameSerialNumber && frameSerialNumber.forEach(item => { url_ += "frameSerialNumber=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressorData_GetClearancesForCompressor(_response);
        });
    }

    protected processCompressorData_GetClearancesForCompressor(response: AxiosResponse): Promise<HistoricalPropertyValuesForCompressor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HistoricalPropertyValuesForCompressor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoricalPropertyValuesForCompressor[]>(null as any);
    }

    compressorData_GetGasesForCompressors(frameSerialNumber?: string[] | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, cancelToken?: CancelToken): Promise<HistoricalPropertyValuesForCompressor[]> {
        let url_ = this.baseUrl + "/api/external/compressors/gases?";
        if (frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' cannot be null.");
        else if (frameSerialNumber !== undefined)
            frameSerialNumber && frameSerialNumber.forEach(item => { url_ += "frameSerialNumber=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressorData_GetGasesForCompressors(_response);
        });
    }

    protected processCompressorData_GetGasesForCompressors(response: AxiosResponse): Promise<HistoricalPropertyValuesForCompressor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HistoricalPropertyValuesForCompressor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoricalPropertyValuesForCompressor[]>(null as any);
    }

    legacyThingworx_GetLegacyCompressorStatusSummary(body: LegacyCompressorFrameIdDTO, cancelToken?: CancelToken): Promise<CompressorStatusSummary_LegacyWrapper> {
        let url_ = this.baseUrl + "/Thingworx/Things/ASC.API_V1/Services/GetCompressorStatusSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLegacyThingworx_GetLegacyCompressorStatusSummary(_response);
        });
    }

    protected processLegacyThingworx_GetLegacyCompressorStatusSummary(response: AxiosResponse): Promise<CompressorStatusSummary_LegacyWrapper> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorStatusSummary_LegacyWrapper>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorStatusSummary_LegacyWrapper>(null as any);
    }

    r_D_GetAvailableVariablesForFrame(frameSerialNumber: string, cancelToken?: CancelToken): Promise<ChartingVariable[]> {
        let url_ = this.baseUrl + "/api/external/{frameSerialNumber}/variables";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processR_D_GetAvailableVariablesForFrame(_response);
        });
    }

    protected processR_D_GetAvailableVariablesForFrame(response: AxiosResponse): Promise<ChartingVariable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChartingVariable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartingVariable[]>(null as any);
    }

    r_D_GetChartData(parameters: ChartingDataParams, cancelToken?: CancelToken): Promise<ChartingVariable[]> {
        let url_ = this.baseUrl + "/api/external/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processR_D_GetChartData(_response);
        });
    }

    protected processR_D_GetChartData(response: AxiosResponse): Promise<ChartingVariable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChartingVariable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartingVariable[]>(null as any);
    }

    r_D_GetClearanceData(frameSerialNumber: string, cancelToken?: CancelToken): Promise<CompressorPropertyWithValue[]> {
        let url_ = this.baseUrl + "/api/external/{frameSerialNumber}/clearance";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processR_D_GetClearanceData(_response);
        });
    }

    protected processR_D_GetClearanceData(response: AxiosResponse): Promise<CompressorPropertyWithValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorPropertyWithValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorPropertyWithValue[]>(null as any);
    }

    r_D_GetCompressors( cancelToken?: CancelToken): Promise<Compressor[]> {
        let url_ = this.baseUrl + "/api/external/compressors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processR_D_GetCompressors(_response);
        });
    }

    protected processR_D_GetCompressors(response: AxiosResponse): Promise<Compressor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Compressor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Compressor[]>(null as any);
    }

    bearing_GetBearingTemperatures(frameSerialNumber: string, cancelToken?: CancelToken): Promise<CompressorPropertyWithValue[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/bearings/temperatures";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBearing_GetBearingTemperatures(_response);
        });
    }

    protected processBearing_GetBearingTemperatures(response: AxiosResponse): Promise<CompressorPropertyWithValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorPropertyWithValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorPropertyWithValue[]>(null as any);
    }

    chart_GetChartVariables(frameId: string, cancelToken?: CancelToken): Promise<ChartingVariable[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/charts/variables";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChart_GetChartVariables(_response);
        });
    }

    protected processChart_GetChartVariables(response: AxiosResponse): Promise<ChartingVariable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChartingVariable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartingVariable[]>(null as any);
    }

    chart_GetChartData(parameters: ChartingDataParams, cancelToken?: CancelToken): Promise<ChartingVariable[]> {
        let url_ = this.baseUrl + "/api/charts/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChart_GetChartData(_response);
        });
    }

    protected processChart_GetChartData(response: AxiosResponse): Promise<ChartingVariable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChartingVariable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartingVariable[]>(null as any);
    }

    chart_GetLubeOilChartData(parameters: ChartingDataParams, cancelToken?: CancelToken): Promise<LubeOilChartData> {
        let url_ = this.baseUrl + "/api/charts/data/lubeOil";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChart_GetLubeOilChartData(_response);
        });
    }

    protected processChart_GetLubeOilChartData(response: AxiosResponse): Promise<LubeOilChartData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LubeOilChartData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LubeOilChartData>(null as any);
    }

    chart_GetChartDataForExport(parameters: ChartingDataParams, cancelToken?: CancelToken): Promise<{ [key: string]: string; }[]> {
        let url_ = this.baseUrl + "/api/charts/data/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChart_GetChartDataForExport(_response);
        });
    }

    protected processChart_GetChartDataForExport(response: AxiosResponse): Promise<{ [key: string]: string; }[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }[]>(null as any);
    }

    cylinder_GetTelemetryProperties(cylinderSN: string, frameSerialNumber?: string | undefined, isHETandem?: boolean | undefined, cancelToken?: CancelToken): Promise<CylinderTelemetryProperty[]> {
        let url_ = this.baseUrl + "/api/cylinders/{cylinderSN}/telemetryProperties?";
        if (cylinderSN === undefined || cylinderSN === null)
            throw new Error("The parameter 'cylinderSN' must be defined.");
        url_ = url_.replace("{cylinderSN}", encodeURIComponent("" + cylinderSN));
        if (frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' cannot be null.");
        else if (frameSerialNumber !== undefined)
            url_ += "frameSerialNumber=" + encodeURIComponent("" + frameSerialNumber) + "&";
        if (isHETandem === null)
            throw new Error("The parameter 'isHETandem' cannot be null.");
        else if (isHETandem !== undefined)
            url_ += "isHETandem=" + encodeURIComponent("" + isHETandem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCylinder_GetTelemetryProperties(_response);
        });
    }

    protected processCylinder_GetTelemetryProperties(response: AxiosResponse): Promise<CylinderTelemetryProperty[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CylinderTelemetryProperty[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CylinderTelemetryProperty[]>(null as any);
    }

    cylinder_GetCylinderEndTelemetry(cylinderSerialNumber: string, frameSerialNumber?: string | undefined, throwNumber?: string | undefined, cancelToken?: CancelToken): Promise<DisplayNameValue[]> {
        let url_ = this.baseUrl + "/api/cylinders/{cylinderSerialNumber}/telemetryProperties/end?";
        if (cylinderSerialNumber === undefined || cylinderSerialNumber === null)
            throw new Error("The parameter 'cylinderSerialNumber' must be defined.");
        url_ = url_.replace("{cylinderSerialNumber}", encodeURIComponent("" + cylinderSerialNumber));
        if (frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' cannot be null.");
        else if (frameSerialNumber !== undefined)
            url_ += "frameSerialNumber=" + encodeURIComponent("" + frameSerialNumber) + "&";
        if (throwNumber === null)
            throw new Error("The parameter 'throwNumber' cannot be null.");
        else if (throwNumber !== undefined)
            url_ += "throwNumber=" + encodeURIComponent("" + throwNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCylinder_GetCylinderEndTelemetry(_response);
        });
    }

    protected processCylinder_GetCylinderEndTelemetry(response: AxiosResponse): Promise<DisplayNameValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DisplayNameValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisplayNameValue[]>(null as any);
    }

    defaultNotification_GetDefaultNotificationsForCompressor(frameSerialNumber: string, cancelToken?: CancelToken): Promise<DefaultNotificationDTO[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/defaultNotifications";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDefaultNotification_GetDefaultNotificationsForCompressor(_response);
        });
    }

    protected processDefaultNotification_GetDefaultNotificationsForCompressor(response: AxiosResponse): Promise<DefaultNotificationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DefaultNotificationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultNotificationDTO[]>(null as any);
    }

    defaultNotification_UpdateNotificationForCompressorAndUser(frameSerialNumber: string, notificationToUpdate: DefaultNotificationDTO, cancelToken?: CancelToken): Promise<DefaultNotificationDTO> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/defaultNotifications";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationToUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDefaultNotification_UpdateNotificationForCompressorAndUser(_response);
        });
    }

    protected processDefaultNotification_UpdateNotificationForCompressorAndUser(response: AxiosResponse): Promise<DefaultNotificationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DefaultNotificationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultNotificationDTO>(null as any);
    }

    favorites_AddFavorite(frameSerialNumber: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/favorites/{frameSerialNumber}";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFavorites_AddFavorite(_response);
        });
    }

    protected processFavorites_AddFavorite(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    favorites_DeleteFavorite(frameSerialNumber: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/favorites/{frameSerialNumber}";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFavorites_DeleteFavorite(_response);
        });
    }

    protected processFavorites_DeleteFavorite(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    featureFlag_GetFeatureFlags( cancelToken?: CancelToken): Promise<FeatureFlag[]> {
        let url_ = this.baseUrl + "/api/featureFlags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeatureFlag_GetFeatureFlags(_response);
        });
    }

    protected processFeatureFlag_GetFeatureFlags(response: AxiosResponse): Promise<FeatureFlag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FeatureFlag[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureFlag[]>(null as any);
    }

    mlinkFirmware_GetMlinkFirmwareRevisions( cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/mlinkFirmwareRevisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMlinkFirmware_GetMlinkFirmwareRevisions(_response);
        });
    }

    protected processMlinkFirmware_GetMlinkFirmwareRevisions(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    mlinkFirmware_GetMlinkFirmwareRevisionsForCompressors(frameSerialNumbers?: string[] | undefined, cancelToken?: CancelToken): Promise<CompressorMlinkFirmwareRevisionDTO[]> {
        let url_ = this.baseUrl + "/api/compressors/mlinkFirmwareRevisions?";
        if (frameSerialNumbers === null)
            throw new Error("The parameter 'frameSerialNumbers' cannot be null.");
        else if (frameSerialNumbers !== undefined)
            frameSerialNumbers && frameSerialNumbers.forEach(item => { url_ += "frameSerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMlinkFirmware_GetMlinkFirmwareRevisionsForCompressors(_response);
        });
    }

    protected processMlinkFirmware_GetMlinkFirmwareRevisionsForCompressors(response: AxiosResponse): Promise<CompressorMlinkFirmwareRevisionDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorMlinkFirmwareRevisionDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorMlinkFirmwareRevisionDTO[]>(null as any);
    }

    mlinkFirmware_RequestUpdate(updateRequest: RequestFirmwareConfigUpdateDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/compressors/mlinkFirmwareRevisions/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMlinkFirmware_RequestUpdate(_response);
        });
    }

    protected processMlinkFirmware_RequestUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    notification_GetNotificationRulesForCompressor(frameSerialNumber: string, cancelToken?: CancelToken): Promise<CompressorNotificationRule[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/notificationRules";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_GetNotificationRulesForCompressor(_response);
        });
    }

    protected processNotification_GetNotificationRulesForCompressor(response: AxiosResponse): Promise<CompressorNotificationRule[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorNotificationRule[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorNotificationRule[]>(null as any);
    }

    notification_GetNotificationRulesForFleet( cancelToken?: CancelToken): Promise<CompressorNotificationRule[]> {
        let url_ = this.baseUrl + "/api/compressors/notificationRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_GetNotificationRulesForFleet(_response);
        });
    }

    protected processNotification_GetNotificationRulesForFleet(response: AxiosResponse): Promise<CompressorNotificationRule[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorNotificationRule[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorNotificationRule[]>(null as any);
    }

    notification_GetNotificationRuleDetails(notificationRuleID: number, subscriptionID: number, cancelToken?: CancelToken): Promise<NotificationDetail[]> {
        let url_ = this.baseUrl + "/api/notifications/{notificationRuleID}/{subscriptionID}";
        if (notificationRuleID === undefined || notificationRuleID === null)
            throw new Error("The parameter 'notificationRuleID' must be defined.");
        url_ = url_.replace("{notificationRuleID}", encodeURIComponent("" + notificationRuleID));
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_GetNotificationRuleDetails(_response);
        });
    }

    protected processNotification_GetNotificationRuleDetails(response: AxiosResponse): Promise<NotificationDetail[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationDetail[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationDetail[]>(null as any);
    }

    notification_GetCanNotificationBeDeleted(ruleID: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/notifications/{ruleID}/deletestatus";
        if (ruleID === undefined || ruleID === null)
            throw new Error("The parameter 'ruleID' must be defined.");
        url_ = url_.replace("{ruleID}", encodeURIComponent("" + ruleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_GetCanNotificationBeDeleted(_response);
        });
    }

    protected processNotification_GetCanNotificationBeDeleted(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    notification_UpdateNotifications(notificationValues: NotificationRuleValuesDTO, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationValues);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_UpdateNotifications(_response);
        });
    }

    protected processNotification_UpdateNotifications(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    notification_CreateNotification(notificationValues: NotificationRuleValuesDTO, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationValues);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_CreateNotification(_response);
        });
    }

    protected processNotification_CreateNotification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    notification_DeleteNotification(ruleID: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/notifications/{ruleID}";
        if (ruleID === undefined || ruleID === null)
            throw new Error("The parameter 'ruleID' must be defined.");
        url_ = url_.replace("{ruleID}", encodeURIComponent("" + ruleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_DeleteNotification(_response);
        });
    }

    protected processNotification_DeleteNotification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    notification_GetNotificationSubscribers(ruleID: number, cancelToken?: CancelToken): Promise<NotificationSubscriber[]> {
        let url_ = this.baseUrl + "/api/notifications/{ruleID}/subscribers";
        if (ruleID === undefined || ruleID === null)
            throw new Error("The parameter 'ruleID' must be defined.");
        url_ = url_.replace("{ruleID}", encodeURIComponent("" + ruleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification_GetNotificationSubscribers(_response);
        });
    }

    protected processNotification_GetNotificationSubscribers(response: AxiosResponse): Promise<NotificationSubscriber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationSubscriber[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationSubscriber[]>(null as any);
    }

    notificationPreferences_GetNotificationPreferences( cancelToken?: CancelToken): Promise<NotificationPreferences> {
        let url_ = this.baseUrl + "/api/notificationpreferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationPreferences_GetNotificationPreferences(_response);
        });
    }

    protected processNotificationPreferences_GetNotificationPreferences(response: AxiosResponse): Promise<NotificationPreferences> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationPreferences>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationPreferences>(null as any);
    }

    notificationPreferences_UpdatePhoneNumber(verificationCheckDto: VerificationCheckDTO, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/notificationPreferences/phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(verificationCheckDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationPreferences_UpdatePhoneNumber(_response);
        });
    }

    protected processNotificationPreferences_UpdatePhoneNumber(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    organization_GetUserParentOrganizations( cancelToken?: CancelToken): Promise<Organization[]> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_GetUserParentOrganizations(_response);
        });
    }

    protected processOrganization_GetUserParentOrganizations(response: AxiosResponse): Promise<Organization[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Organization[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Organization[]>(null as any);
    }

    organization_GetOrganizationHierarchyForOrg(orgId: number, cancelToken?: CancelToken): Promise<HierarchyItem[]> {
        let url_ = this.baseUrl + "/api/organizations/{orgId}/hierarchy";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_GetOrganizationHierarchyForOrg(_response);
        });
    }

    protected processOrganization_GetOrganizationHierarchyForOrg(response: AxiosResponse): Promise<HierarchyItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HierarchyItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HierarchyItem[]>(null as any);
    }

    organization_GetOrganizationHierarchyForLoggedInUser( cancelToken?: CancelToken): Promise<HierarchyItem[]> {
        let url_ = this.baseUrl + "/api/organizations/hierarchy";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_GetOrganizationHierarchyForLoggedInUser(_response);
        });
    }

    protected processOrganization_GetOrganizationHierarchyForLoggedInUser(response: AxiosResponse): Promise<HierarchyItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HierarchyItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HierarchyItem[]>(null as any);
    }

    organization_GetMembersOnlyUsersForOrganization(organizationId: string, cancelToken?: CancelToken): Promise<MembersOnlyUser[]> {
        let url_ = this.baseUrl + "/api/organizations/mo/{organizationId}/users";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_GetMembersOnlyUsersForOrganization(_response);
        });
    }

    protected processOrganization_GetMembersOnlyUsersForOrganization(response: AxiosResponse): Promise<MembersOnlyUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MembersOnlyUser[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MembersOnlyUser[]>(null as any);
    }

    organization_GetIsArielEmployee( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/organizations/isAriel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_GetIsArielEmployee(_response);
        });
    }

    protected processOrganization_GetIsArielEmployee(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    organization_DeleteUsers(organizationId: string, users: UserToDeleteDTO[], cancelToken?: CancelToken): Promise<DeleteUserResponse> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/users";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(users);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_DeleteUsers(_response);
        });
    }

    protected processOrganization_DeleteUsers(response: AxiosResponse): Promise<DeleteUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeleteUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteUserResponse>(null as any);
    }

    organization_UpdateUser(requestBody: UpdateUserRequestBody, organizationId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/user/update";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_UpdateUser(_response);
        });
    }

    protected processOrganization_UpdateUser(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    organization_CreateCompressorOrgAssociation(frameSerialNumber: string, organizationId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/association";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(frameSerialNumber);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_CreateCompressorOrgAssociation(_response);
        });
    }

    protected processOrganization_CreateCompressorOrgAssociation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    organization_DeleteCompressorOrgAssociation(frameSerialNumber: string, organizationId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/association";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(frameSerialNumber);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_DeleteCompressorOrgAssociation(_response);
        });
    }

    protected processOrganization_DeleteCompressorOrgAssociation(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    organization_GetOrganizationsWithAccessToCompressor(frameSerialNumber: string, cancelToken?: CancelToken): Promise<OrganizationsWithAccessToCompressorDto[]> {
        let url_ = this.baseUrl + "/api/organizations/{frameSerialNumber}";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganization_GetOrganizationsWithAccessToCompressor(_response);
        });
    }

    protected processOrganization_GetOrganizationsWithAccessToCompressor(response: AxiosResponse): Promise<OrganizationsWithAccessToCompressorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationsWithAccessToCompressorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationsWithAccessToCompressorDto[]>(null as any);
    }

    packingVent_GetPackingVentPredictions(organizationId?: number | null | undefined, cancelToken?: CancelToken): Promise<FleetPackingData> {
        let url_ = this.baseUrl + "/api/packingVent/predictions?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPackingVent_GetPackingVentPredictions(_response);
        });
    }

    protected processPackingVent_GetPackingVentPredictions(response: AxiosResponse): Promise<FleetPackingData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FleetPackingData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetPackingData>(null as any);
    }

    packingVent_GetPackingVentDataForCompressor(frameSerialNumber: string, startDate?: string | undefined, endDate?: string | undefined, cancelToken?: CancelToken): Promise<FramePackingHistoricalData> {
        let url_ = this.baseUrl + "/api/packingVent/predictions/{frameSerialNumber}?";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPackingVent_GetPackingVentDataForCompressor(_response);
        });
    }

    protected processPackingVent_GetPackingVentDataForCompressor(response: AxiosResponse): Promise<FramePackingHistoricalData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FramePackingHistoricalData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FramePackingHistoricalData>(null as any);
    }

    report_GetFleetSoftwareVersionReport( cancelToken?: CancelToken): Promise<SoftwareVersionFleetReport[]> {
        let url_ = this.baseUrl + "/api/reports/software/version/fleet";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport_GetFleetSoftwareVersionReport(_response);
        });
    }

    protected processReport_GetFleetSoftwareVersionReport(response: AxiosResponse): Promise<SoftwareVersionFleetReport[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SoftwareVersionFleetReport[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SoftwareVersionFleetReport[]>(null as any);
    }

    report_GetDataQualityReportForFrame(frameSerialNumber: string, cancelToken?: CancelToken): Promise<DataQualityReport> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/reports/dataquality";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport_GetDataQualityReportForFrame(_response);
        });
    }

    protected processReport_GetDataQualityReportForFrame(response: AxiosResponse): Promise<DataQualityReport> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataQualityReport>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataQualityReport>(null as any);
    }

    report_GetDataQualitySummaryForFrame(frameSerialNumber: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/reports/dataquality/summary";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport_GetDataQualitySummaryForFrame(_response);
        });
    }

    protected processReport_GetDataQualitySummaryForFrame(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    report_GetDataQualityReportsForFleet(organizationId?: number | null | undefined, cancelToken?: CancelToken): Promise<DataQualityReport[]> {
        let url_ = this.baseUrl + "/api/compressors/reports/dataquality?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport_GetDataQualityReportsForFleet(_response);
        });
    }

    protected processReport_GetDataQualityReportsForFleet(response: AxiosResponse): Promise<DataQualityReport[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataQualityReport[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataQualityReport[]>(null as any);
    }

    sensorReliability_GetFleetSensorReliabilityReport(organizationId?: number | null | undefined, cancelToken?: CancelToken): Promise<FleetSensorReliabilitySummary> {
        let url_ = this.baseUrl + "/api/sensorReliability/fleetReport?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSensorReliability_GetFleetSensorReliabilityReport(_response);
        });
    }

    protected processSensorReliability_GetFleetSensorReliabilityReport(response: AxiosResponse): Promise<FleetSensorReliabilitySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FleetSensorReliabilitySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetSensorReliabilitySummary>(null as any);
    }

    sensorReliability_GetHistoricalFleetSensorReliabilityReport(startDate?: string | undefined, endDate?: string | undefined, organizationId?: number | null | undefined, cancelToken?: CancelToken): Promise<HistoricalFleetSensorReliabilitySummary> {
        let url_ = this.baseUrl + "/api/sensorReliability/fleetReport/historical?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSensorReliability_GetHistoricalFleetSensorReliabilityReport(_response);
        });
    }

    protected processSensorReliability_GetHistoricalFleetSensorReliabilityReport(response: AxiosResponse): Promise<HistoricalFleetSensorReliabilitySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HistoricalFleetSensorReliabilitySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoricalFleetSensorReliabilitySummary>(null as any);
    }

    termsAndConditions_GetTermsAndConditions( cancelToken?: CancelToken): Promise<TermsAndConditions> {
        let url_ = this.baseUrl + "/api/termsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTermsAndConditions_GetTermsAndConditions(_response);
        });
    }

    protected processTermsAndConditions_GetTermsAndConditions(response: AxiosResponse): Promise<TermsAndConditions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TermsAndConditions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsAndConditions>(null as any);
    }

    termsAndConditions_GetTermsAndConditionsStatus( cancelToken?: CancelToken): Promise<TermsAndConditionsStatus> {
        let url_ = this.baseUrl + "/api/termsAndConditions/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTermsAndConditions_GetTermsAndConditionsStatus(_response);
        });
    }

    protected processTermsAndConditions_GetTermsAndConditionsStatus(response: AxiosResponse): Promise<TermsAndConditionsStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TermsAndConditionsStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsAndConditionsStatus>(null as any);
    }

    termsAndConditions_UpdateTermsAndConditionsStatus(status: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/termsAndConditions/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTermsAndConditions_UpdateTermsAndConditionsStatus(_response);
        });
    }

    protected processTermsAndConditions_UpdateTermsAndConditionsStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    verificationCode_SendVerification(phoneNumber: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(phoneNumber);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerificationCode_SendVerification(_response);
        });
    }

    protected processVerificationCode_SendVerification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    verificationCode_CheckVerification(body: VerificationCheckDTO, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/verification/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerificationCode_CheckVerification(_response);
        });
    }

    protected processVerificationCode_CheckVerification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    vibrations_GetVibrationData(frameSerialNumber: string, cancelToken?: CancelToken): Promise<VibrationOverviewResponse> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/vibration";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVibrations_GetVibrationData(_response);
        });
    }

    protected processVibrations_GetVibrationData(response: AxiosResponse): Promise<VibrationOverviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VibrationOverviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VibrationOverviewResponse>(null as any);
    }

    alert_Get(alertResolutionType?: string | undefined, resolutionStartDate?: string | null | undefined, resolutionEndDate?: string | null | undefined, cancelToken?: CancelToken): Promise<CompressorAlert[]> {
        let url_ = this.baseUrl + "/api/alerts?";
        if (alertResolutionType === null)
            throw new Error("The parameter 'alertResolutionType' cannot be null.");
        else if (alertResolutionType !== undefined)
            url_ += "alertResolutionType=" + encodeURIComponent("" + alertResolutionType) + "&";
        if (resolutionStartDate !== undefined && resolutionStartDate !== null)
            url_ += "resolutionStartDate=" + encodeURIComponent("" + resolutionStartDate) + "&";
        if (resolutionEndDate !== undefined && resolutionEndDate !== null)
            url_ += "resolutionEndDate=" + encodeURIComponent("" + resolutionEndDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlert_Get(_response);
        });
    }

    protected processAlert_Get(response: AxiosResponse): Promise<CompressorAlert[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorAlert[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorAlert[]>(null as any);
    }

    alert_GetAlertSetPoints(frameId: string, cancelToken?: CancelToken): Promise<AlertSetPoint[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/alerts/setpoints";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlert_GetAlertSetPoints(_response);
        });
    }

    protected processAlert_GetAlertSetPoints(response: AxiosResponse): Promise<AlertSetPoint[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AlertSetPoint[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlertSetPoint[]>(null as any);
    }

    alert_GetCompressorAlertsByResolutionStatus(frameId: string, alertResolutionType?: string | undefined, resolutionStartDate?: string | null | undefined, resolutionEndDate?: string | null | undefined, cancelToken?: CancelToken): Promise<CompressorAlert[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/alerts?";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        if (alertResolutionType === null)
            throw new Error("The parameter 'alertResolutionType' cannot be null.");
        else if (alertResolutionType !== undefined)
            url_ += "alertResolutionType=" + encodeURIComponent("" + alertResolutionType) + "&";
        if (resolutionStartDate !== undefined && resolutionStartDate !== null)
            url_ += "resolutionStartDate=" + encodeURIComponent("" + resolutionStartDate) + "&";
        if (resolutionEndDate !== undefined && resolutionEndDate !== null)
            url_ += "resolutionEndDate=" + encodeURIComponent("" + resolutionEndDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlert_GetCompressorAlertsByResolutionStatus(_response);
        });
    }

    protected processAlert_GetCompressorAlertsByResolutionStatus(response: AxiosResponse): Promise<CompressorAlert[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorAlert[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorAlert[]>(null as any);
    }

    alert_GetAllCompressorAlertsForTimeRange(frameSerialNumber: string, startDate?: string | undefined, endDate?: string | undefined, cancelToken?: CancelToken): Promise<CompressorAlert[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/charts/alerts?";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlert_GetAllCompressorAlertsForTimeRange(_response);
        });
    }

    protected processAlert_GetAllCompressorAlertsForTimeRange(response: AxiosResponse): Promise<CompressorAlert[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorAlert[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorAlert[]>(null as any);
    }

    alert_GetFaultRepositoryEntries( cancelToken?: CancelToken): Promise<FaultRepositoryGenericFaultGroup[]> {
        let url_ = this.baseUrl + "/api/faultRepositoryEntries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlert_GetFaultRepositoryEntries(_response);
        });
    }

    protected processAlert_GetFaultRepositoryEntries(response: AxiosResponse): Promise<FaultRepositoryGenericFaultGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FaultRepositoryGenericFaultGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FaultRepositoryGenericFaultGroup[]>(null as any);
    }

    compressor_GetAll(onlyFavorites?: boolean | undefined, cancelToken?: CancelToken): Promise<Compressor[]> {
        let url_ = this.baseUrl + "/api/compressors?";
        if (onlyFavorites === null)
            throw new Error("The parameter 'onlyFavorites' cannot be null.");
        else if (onlyFavorites !== undefined)
            url_ += "OnlyFavorites=" + encodeURIComponent("" + onlyFavorites) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetAll(_response);
        });
    }

    protected processCompressor_GetAll(response: AxiosResponse): Promise<Compressor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Compressor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Compressor[]>(null as any);
    }

    compressor_GetCompressorConditions(frameId: string, cancelToken?: CancelToken): Promise<CompressorConditions> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/conditions";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetCompressorConditions(_response);
        });
    }

    protected processCompressor_GetCompressorConditions(response: AxiosResponse): Promise<CompressorConditions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorConditions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorConditions>(null as any);
    }

    compressor_Get(frameId: string, cancelToken?: CancelToken): Promise<CompressorBasicInformation> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_Get(_response);
        });
    }

    protected processCompressor_Get(response: AxiosResponse): Promise<CompressorBasicInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorBasicInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorBasicInformation>(null as any);
    }

    compressor_GetCompressorOperationalStatusCode(frameId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/statuscode";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetCompressorOperationalStatusCode(_response);
        });
    }

    protected processCompressor_GetCompressorOperationalStatusCode(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    compressor_GetCompressorStatus(frameId: string, cancelToken?: CancelToken): Promise<CompressorStatus> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/status";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetCompressorStatus(_response);
        });
    }

    protected processCompressor_GetCompressorStatus(response: AxiosResponse): Promise<CompressorStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorStatus>(null as any);
    }

    compressor_UpdateCompressorEndUserUnitId(frameId: string, endUserUnitId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/endUserUnitId?";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        if (endUserUnitId === null)
            throw new Error("The parameter 'endUserUnitId' cannot be null.");
        else if (endUserUnitId !== undefined)
            url_ += "endUserUnitId=" + encodeURIComponent("" + endUserUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_UpdateCompressorEndUserUnitId(_response);
        });
    }

    protected processCompressor_UpdateCompressorEndUserUnitId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    compressor_GetCurrentValveDataForCompressor(frameSerialNumber: string, cancelToken?: CancelToken): Promise<StageValveTempAndLeakIndexData[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/valves/conditions";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetCurrentValveDataForCompressor(_response);
        });
    }

    protected processCompressor_GetCurrentValveDataForCompressor(response: AxiosResponse): Promise<StageValveTempAndLeakIndexData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StageValveTempAndLeakIndexData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StageValveTempAndLeakIndexData[]>(null as any);
    }

    compressor_GetCompressorStatusSummary(frameId: string, cancelToken?: CancelToken): Promise<CompressorStatusSummary[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameId}/statusSummary";
        if (frameId === undefined || frameId === null)
            throw new Error("The parameter 'frameId' must be defined.");
        url_ = url_.replace("{frameId}", encodeURIComponent("" + frameId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetCompressorStatusSummary(_response);
        });
    }

    protected processCompressor_GetCompressorStatusSummary(response: AxiosResponse): Promise<CompressorStatusSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorStatusSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorStatusSummary[]>(null as any);
    }

    compressor_GetLubeOilConditions(frameSerialNumber: string, volumeUnits?: VolumeUnits | undefined, cancelToken?: CancelToken): Promise<LubeOilData> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/lubeoildata?";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        if (volumeUnits === null)
            throw new Error("The parameter 'volumeUnits' cannot be null.");
        else if (volumeUnits !== undefined)
            url_ += "volumeUnits=" + encodeURIComponent("" + volumeUnits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetLubeOilConditions(_response);
        });
    }

    protected processCompressor_GetLubeOilConditions(response: AxiosResponse): Promise<LubeOilData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LubeOilData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LubeOilData>(null as any);
    }

    compressor_GetConfigDiagram(frameSerialNumber: string, cancelToken?: CancelToken): Promise<ISerialNumberedEquipment[][]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/config/diagram";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetConfigDiagram(_response);
        });
    }

    protected processCompressor_GetConfigDiagram(response: AxiosResponse): Promise<ISerialNumberedEquipment[][]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ISerialNumberedEquipment[][]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ISerialNumberedEquipment[][]>(null as any);
    }

    compressor_GetThrowRodLoadTelemetry(frameSerialNumber: string, throwNumber: string, cancelToken?: CancelToken): Promise<DisplayNameValue[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/throw{throwNumber}/telemetry/rodload";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        if (throwNumber === undefined || throwNumber === null)
            throw new Error("The parameter 'throwNumber' must be defined.");
        url_ = url_.replace("{throwNumber}", encodeURIComponent("" + throwNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetThrowRodLoadTelemetry(_response);
        });
    }

    protected processCompressor_GetThrowRodLoadTelemetry(response: AxiosResponse): Promise<DisplayNameValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DisplayNameValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisplayNameValue[]>(null as any);
    }

    compressor_GetThrowStageMapping(frameSerialNumber: string, cancelToken?: CancelToken): Promise<ThrowStageMapping[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/throwstagemapping";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetThrowStageMapping(_response);
        });
    }

    protected processCompressor_GetThrowStageMapping(response: AxiosResponse): Promise<ThrowStageMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ThrowStageMapping[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThrowStageMapping[]>(null as any);
    }

    compressor_GetPropertiesForCompressor(frameSerialNumber: string, cancelToken?: CancelToken): Promise<CompressorProperty[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/properties";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetPropertiesForCompressor(_response);
        });
    }

    protected processCompressor_GetPropertiesForCompressor(response: AxiosResponse): Promise<CompressorProperty[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorProperty[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorProperty[]>(null as any);
    }

    compressor_GetTelemetryReadings(frameSerialNumber: string, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/telemetry";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetTelemetryReadings(_response);
        });
    }

    protected processCompressor_GetTelemetryReadings(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    compressor_GetEndUser(frameSerialNumber: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/enduser";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetEndUser(_response);
        });
    }

    protected processCompressor_GetEndUser(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    compressor_UpdateEndUserForCompressor(frameSerialNumber: string, subOrgName: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/enduser";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subOrgName);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_UpdateEndUserForCompressor(_response);
        });
    }

    protected processCompressor_UpdateEndUserForCompressor(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    compressor_GetCurrentSetPointsForCompressor(frameSerialNumber: string, cancelToken?: CancelToken): Promise<CompressorPropertyWithValue[]> {
        let url_ = this.baseUrl + "/api/compressors/{frameSerialNumber}/setpoints";
        if (frameSerialNumber === undefined || frameSerialNumber === null)
            throw new Error("The parameter 'frameSerialNumber' must be defined.");
        url_ = url_.replace("{frameSerialNumber}", encodeURIComponent("" + frameSerialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetCurrentSetPointsForCompressor(_response);
        });
    }

    protected processCompressor_GetCurrentSetPointsForCompressor(response: AxiosResponse): Promise<CompressorPropertyWithValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorPropertyWithValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorPropertyWithValue[]>(null as any);
    }

    compressor_GetLatestLocationForCompressors( cancelToken?: CancelToken): Promise<CompressorLatLong[]> {
        let url_ = this.baseUrl + "/api/compressors/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompressor_GetLatestLocationForCompressors(_response);
        });
    }

    protected processCompressor_GetLatestLocationForCompressors(response: AxiosResponse): Promise<CompressorLatLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompressorLatLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompressorLatLong[]>(null as any);
    }

    config_Get( cancelToken?: CancelToken): Promise<FrontEndConfig> {
        let url_ = this.baseUrl + "/api/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfig_Get(_response);
        });
    }

    protected processConfig_Get(response: AxiosResponse): Promise<FrontEndConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FrontEndConfig>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FrontEndConfig>(null as any);
    }
}

export interface CompressorAlert_ExternallyShared {
    severity: string;
    frameSerialNumber: string;
    faultDescription: string;
    faultTimeStamp: string;
    resolutionTimeStamp: string | undefined;
    source: string;
    faultCategory: string;
}

export interface HistoricalPropertyValuesForCompressor {
    frameSerialNumber: string;
    startDate: string;
    endDate: string;
    data: CompressorPropertyWithHistoricValues[];
}

export interface CompressorProperty {
    ascPropertyName: string;
    displayName: string;
    unitOfMeasure: string | undefined;
}

export interface CompressorPropertyWithHistoricValues extends CompressorProperty {
    values: { [key: string]: string; };
}

export interface CompressorStatusSummary_LegacyWrapper {
    array: CompressorStatusSummary_Legacy[];
}

export interface CompressorStatusSummary_Legacy {
    code: string;
    sort: number;
    title: string;
    url: string;
    status: CompressorStatus_Legacy;
}

export interface CompressorStatus_Legacy {
    statusDescription: string;
    statusColor: string;
    statusCode: number;
}

export interface LegacyCompressorFrameIdDTO {
    frameID: string;
}

export interface ChartingVariable extends CompressorProperty {
    graphDataPoints: GraphPointOfStringAndDouble[];
    digitalTwin: ChartingVariable | undefined;
}

export interface GraphPointOfStringAndDouble {
    x: string | undefined;
    y: number;
}

export interface ChartingDataParams {
    frameSerialNumber: string;
    startDate: string;
    endDate: string;
    variables: ChartingVariable[];
}

export interface CompressorPropertyWithValue extends CompressorProperty {
    value: string;
}

export interface Compressor {
    frameSerialNumber: string;
    endUserUnitId: string;
    model: string;
    isFavorite: boolean;
    faultCategories: string;
    statusCode: CompressorStatusCode;
}

export enum CompressorStatusCode {
    ShutdownFault = 0,
    ActiveWarning = 1,
    OK = 2,
    NonASC = 3,
    NormalShutdown = 4,
    Disconnected = 5,
    Unknown = 6,
    RunningShutdownFault = 7,
}

export interface LubeOilChartData {
    frameSerialNumber: string;
    compressorSpeed: ChartingVariable;
    forceFeedOddCycleTime: ChartingVariable;
    forceFeedEvenCycleTime: ChartingVariable;
}

export interface CylinderTelemetryProperty {
    displayName: string;
    measured: number | undefined;
    calculated: number | undefined;
    difference: number | undefined;
    units: string;
}

export interface DisplayNameValue {
    displayName: string;
    value: string;
}

export interface DefaultNotificationDTO {
    id: number;
    description: string;
    isSmsEnabled: boolean;
    isEmailEnabled: boolean;
}

export interface FeatureFlag {
    name: string;
}

export interface CompressorMlinkFirmwareRevisionDTO {
    frameSerialNumber: string;
    mlinkFirmwareRevision: string;
}

export interface RequestFirmwareConfigUpdateDTO {
    frameSerialNumber: string;
    firmwareRevision: string;
    notes: string;
}

export interface CompressorNotificationRule {
    id: number;
    subscriptionID: number;
    valueLimit: number;
    property: string;
    operand: string;
    frameSerialNumber: string;
    description: string;
    createdBy: string;
    createdDate: string | undefined;
    isSmsEnabled: boolean;
    isEmailEnabled: boolean;
    isGlobal: boolean;
    timeout: number;
    message: string;
}

export interface NotificationDetail extends CompressorNotificationRule {
    notificationPropertyFriendlyName: string;
    notificationDetails: string;
    unitOfMeasure: string;
    notificationTimeout: number;
    message: string;
    subscriptionId: number;
    subscriptionNotificationTimeout: number;
    subscriptionTimestamp: string;
}

export interface NotificationRuleValuesDTO {
    ruleID: number;
    isEmailEnabled: boolean;
    subscriptionID: number;
    isSmsEnabled: boolean;
    notificationTimeout: number;
    message: string;
    frameSerialNumber: string;
    property: string;
    operand: string;
    description: string;
    value: number;
}

export interface NotificationSubscriber {
    username: string;
    isEmailEnabled: boolean;
    isSmsEnabled: boolean;
    frameSerialNumber: string;
}

export interface NotificationPreferences {
    email: string;
    phoneNumber: string;
}

export interface VerificationCheckDTO {
    phoneNumber: string;
    verificationCode: string;
}

export interface Organization {
    externalId: string;
    id: string;
    name: string;
    organizationalUnit: string;
}

export interface HierarchyItem {
    id: string;
    name: string;
    type: HierarchyItemType;
    discriminator: string;
}

export enum HierarchyItemType {
    Frame = 0,
    Org = 1,
}

export interface OrganizationHierarchyItem extends HierarchyItem {
    children: HierarchyItem[];
    members: OrganizationMember[];
}

export interface OrganizationMember {
    username: string;
    role: UserRole;
    lastAccess: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    organizationalUnit: string;
    email: string;
}

export enum UserRole {
    Administrator = 0,
    User = 1,
}

export interface MembersOnlyUser {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    displayName: string;
}

export interface DeleteUserResponse {
    success: DeleteUserResponseInfo[];
    failure: DeleteUserResponseInfo[];
}

export interface DeleteUserResponseInfo {
    username: string;
    organizationalUnit: string;
    message: string;
}

export interface UserToDeleteDTO {
    username: string;
    organizationalUnit: string;
}

export interface Response {
    isSuccess: boolean;
    message: string;
}

export interface UpdateUserRequestBody {
    currentUserData: UserInfoDTO;
    updatedUserData: UserInfoDTO;
    organization: string;
}

export interface UserInfoDTO {
    username: string;
    firstName: string;
    lastName: string;
    role: string;
    lastAccess: string;
    phone: string;
    emailAddress: string;
    organizationalUnit: string;
}

export interface OrganizationsWithAccessToCompressorDto {
    name: string;
}

export interface FleetPackingData {
    averageLeakSeverity: number;
    packingCount: number;
    normalOperationCount: number;
    failedInstrumentationCount: number;
    leakDetectedCount: number;
    m_LinkConfigErrorCount: number;
    abnormalTemperatureCount: number;
    unknownCount: number;
    framePackingData: FramePackingData[];
}

export interface FramePackingData {
    frameSerialNumber: string;
    averageLeakSeverity: number;
    packingCount: number;
    normalOperationCount: number;
    failedInstrumentationCount: number;
    leakDetectedCount: number;
    m_LinkConfigErrorCount: number;
    abnormalTemperatureCount: number;
    unknownCount: number;
    throwPackingData: ThrowPackingData[];
}

export interface ThrowPackingData {
    throwNumber: number;
    eventTime: string;
    packingVentTemperature: number;
    prediction: Prediction;
    leakSeverity: number;
    packingLongitude: number;
    packingLatitude: number;
}

export enum Prediction {
    NormalOperation = 0,
    FailedInstrumentation = 1,
    LeakDetected = 2,
    M_LinkConfigError = 3,
    AbnormalTemperature = 4,
    Unknown = 5,
}

export interface FramePackingHistoricalData {
    frameSerialNumber: string;
    throwPackingHistoricalData: ThrowPackingHistoricalData[];
}

export interface ThrowPackingCurrentData {
    throwNumber: number;
    prediction: ThrowPackingPrediction;
}

export interface ThrowPackingHistoricalData extends ThrowPackingCurrentData {
    packingVentTemperatures: PackingGraphDataPoint[];
}

export interface PackingGraphDataPoint {
    x: string;
    y: number;
    prediction: Prediction;
}

export interface ThrowPackingPrediction {
    normalOperation: number;
    failedInstrumentation: number;
    leakDetected: number;
    m_LinkConfigError: number;
    abnormalTemperature: number;
}

export interface SoftwareVersionFleetReport {
    compressorSN: string;
    endUserUnitID: string;
    provisioningDate: string;
    activeCarrier: string;
    motFileRev: string;
    mLinkSerial: string;
    firmwareVersion: string;
}

export interface DataQualityReport {
    frameSerialNumber: string;
    endUserUnitId: string;
    mLinkSerial: string;
    missingVariableCount: number;
    extraVariableCount: number;
    correctVariableCount: number;
    variableComplianceStatuses: VariableComplianceStatus[];
}

export interface VariableComplianceStatus {
    displayName: string;
    ascPropertyName: string;
    ccpAddress: string;
    isRequired: boolean;
    isSent: boolean;
}

export interface FleetSensorReliabilitySummary {
    totalSensors: number;
    failedSensors: number;
    newFailures: number;
    meanTimeAtFailure: number;
    medianTimeAtFailure: number;
    minTimeAtFailure: number;
    valveCapSensorFailureCount: number;
    cylinderSensorFailureCount: number;
    speedSensorFailureCount: number;
    mainBearingSensorFailureCount: number;
    oilSensorFailureCount: number;
    packingVentSensorFailureCount: number;
    thrustBearingSensorFailureCount: number;
    newFailureCount: number;
    oldFailureCount: number;
    frameSensorReliabilitySummaries: FrameSensorReliabilitySummary[];
}

export interface FrameSensorReliabilitySummary {
    frameSerialNumber: string;
    totalSensors: number;
    failedSensors: number;
    newFailures: number;
    meanTimeAtFailure: number;
    medianTimeAtFailure: number;
    minTimeAtFailure: number;
    valveCapSensorFailureCount: number;
    cylinderSensorFailureCount: number;
    speedSensorFailureCount: number;
    mainBearingSensorFailureCount: number;
    oilSensorFailureCount: number;
    packingVentSensorFailureCount: number;
    thrustBearingSensorFailureCount: number;
    newFailureCount: number;
    oldFailureCount: number;
    frameSensorFailureInstances: SensorFailureInstance[];
    throwSensorReliabilitySummaries: ThrowSensorReliabilitySummary[];
}

export interface SensorFailureInstance {
    description: string;
    variableName: string;
    timeFailed: string | undefined;
    estimatedHoursAtFailure: number | undefined;
    category: SensorFailureCategory;
    sensorType: SensorType;
    side: FlowDirection | undefined;
    locationEnd: CylinderEnd | undefined;
    uniqueSensor: string | undefined;
    failedSensor: boolean | undefined;
    newFailure: boolean | undefined;
    alerts: string[];
}

export enum SensorFailureCategory {
    ValveCap = 0,
    Cylinder = 1,
    Speed = 2,
    MainBearing = 3,
    Oil = 4,
    PackingVent = 5,
    ThrustBearing = 6,
    Unknown = 7,
}

export enum SensorType {
    Pressure = 0,
    Temperature = 1,
    RPM = 2,
    Unknown = 3,
}

export enum FlowDirection {
    Suction = 0,
    Discharge = 1,
}

export enum CylinderEnd {
    HE = 0,
    CE = 1,
}

export interface ThrowSensorReliabilitySummary {
    throwNumber: number;
    sensorFailureInstances: SensorFailureInstance[];
}

export interface HistoricalFleetSensorReliabilitySummary {
    totalSensors: number;
    failedSensors: number;
    newFailures: number;
    meanTimeAtFailure: number;
    medianTimeAtFailure: number;
    minTimeAtFailure: number;
    valveCapSensorFailureCount: number;
    cylinderSensorFailureCount: number;
    speedSensorFailureCount: number;
    mainBearingSensorFailureCount: number;
    oilSensorFailureCount: number;
    packingVentSensorFailureCount: number;
    thrustBearingSensorFailureCount: number;
    newFailureCount: number;
    oldFailureCount: number;
    sensorFailureInstances: HistoricalSensorFailureInstance[];
}

export interface HistoricalSensorFailureInstance {
    frameSerialNumber: string;
    eventDate: string;
    category: SensorFailureCategory;
    sensorType: SensorType;
    estimatedHoursAtFailure: number | undefined;
    failedSensor: boolean;
    newFailure: boolean;
}

export interface TermsAndConditions {
    text: string;
    version: string;
}

export enum TermsAndConditionsStatus {
    ActionRequired = 1,
    Accepted = 2,
    Denied = 3,
}

export interface VibrationOverviewResponse {
    frameOverview: VibrationOverview | undefined;
    torsionalOverview: VibrationOverview | undefined;
}

export interface VibrationOverview {
    current: DerivedPeakDataPoint;
    average: DerivedPeakDataPoint;
    max: DerivedPeakDataPoint;
    min: DerivedPeakDataPoint;
    worstHarmonic: DerivedPeakDataPoint;
}

export interface DerivedPeakDataPoint {
    atRpm: number | undefined;
    recommendedSetPoint: number | undefined;
    currentSetPoint: string | undefined;
    value: number;
    measurementUnits: string;
}

export interface CompressorAlert {
    severity: CompressorAlertSeverity;
    mlinkDeviceId: string;
    frameSerialNumber: string;
    faultDescription: string;
    faultTimeStamp: string;
    resolutionTimeStamp: string | undefined;
    source: string;
    faultCategory: FaultCategory;
    faultId: number;
    endUserUnitId: string;
}

export enum CompressorAlertSeverity {
    Shutdown = 0,
    Warning = 1,
    NA = 2,
}

export enum FaultCategory {
    Valves = 0,
    Vibration = 1,
    LubeOil = 2,
    RodLoadReversal = 3,
    OperatingConditions = 4,
    ControllerSkid = 5,
    Instrumentation = 6,
    ArielFleetManager = 7,
    Bearings = 8,
    Other = 9,
}

export interface AlertSetPoint {
    setPointName: string;
    faultDescription: string;
    setPointUnits: string;
    setPointValue: number;
    setPointRecommended: string;
}

export interface FaultRepositoryGenericFaultGroup {
    genericDescription: string;
    faults: FaultRepositoryEntry[];
}

export interface FaultRepositoryEntry {
    ascFaultId: number;
    setPointName: string;
    setPointDescription: string;
    faultDescription: string;
    faultGenericDescription: string;
    startingPoints: string[];
    fixes: string[];
    faultTroubleShootingDescription: string;
}

export interface CompressorConditions {
    stages: StageConditionsSummary[];
    driverSpeedRPM: number | undefined;
    flowMMSCFD: number | undefined;
    oilTemperatureF: number | undefined;
    oilPostFilterPressurePSI: number | undefined;
    dailyUptimePercentage: number | undefined;
    driverHours: number | undefined;
}

export interface StageConditionsSummary {
    stageNumber: number;
    suctionPressurePsi: number | undefined;
    dischargePressurePsi: number | undefined;
    suctionTemperatureF: number | undefined;
    dischargeTemperatureF: number | undefined;
    predictedSuctionPressurePsi: number | undefined;
    predictedDischargePressurePsi: number | undefined;
    predictedSuctionTemperatureF: number | undefined;
    predictedDischargeTemperatureF: number | undefined;
}

export interface CompressorBasicInformation {
    model: string;
    distributor: string;
    endUser: string;
    endUserUnitID: string;
    lastUpdated: string;
    location: string;
    mLinkSerial: string;
}

export interface CompressorStatus {
    statusCode: CompressorStatusCode;
    faultCategories: string;
}

export interface StageValveTempAndLeakIndexData {
    stageNumber: number;
    throwValveTempAndLeakIndexData: ThrowValveTempAndLeakIndexData[];
}

export interface ThrowValveTempAndLeakIndexData {
    throwNumber: number;
    valveTempAndLeakIndexData: ValveTempAndLeakIndexData[];
}

export interface ValveTempAndLeakIndexData {
    cylinderEnd: CylinderEnd;
    valveNumber: number;
    flowDirection: FlowDirection;
    tempF: number;
    leakIndex: number;
    displayName: string;
}

export interface CompressorStatusSummary {
    category: FaultCategory;
    sort: number;
    title: string;
    status: CompressorStatusCode;
}

export interface LubeOilData {
    lastRpm: number;
    volumeUnits: VolumeUnits;
    averageCyleTimeSeconds_OddThrows: number;
    averageCyleTimeSeconds_EvenThrows: number;
    lastCycleTime_OddThrows: number;
    lastCycleTime_EvenThrows: number;
    dailyOilConsumption_EvenThrows: number;
    dailyOilConsumption_OddThrows: number;
    totalOilConsumption_PerDay: number;
    totalOilConsumption_PerWeek: number;
    oilPressure: number;
    oilTemperature: number;
    filterPressureDelta: number;
}

export enum VolumeUnits {
    Gallons = 0,
    Pints = 1,
    Liters = 2,
}

export interface ISerialNumberedEquipment {
    serialNumber: string;
    equipmentType: SerialNumberedEquipmentType;
}

export enum SerialNumberedEquipmentType {
    Frame = 0,
    Cylinder = 1,
    Unloader = 2,
}

export interface ThrowStageMapping {
    stage: number;
    throwNumber: number;
    cylinderModel: string;
    cylinderAction: string;
}

export interface CompressorLatLong {
    frameSerialNumber: string;
    latitude: number;
    longitude: number;
}

export interface FrontEndConfig {
    oidcConfig: OidcConfig;
    syncfusionKey: string;
}

export interface OidcConfig {
    loadUserInfo: boolean;
    mergeClaims: boolean;
    authority: string;
    clientId: string;
    responseType: string;
    redirectUri: string;
    scope: string;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}